import React, { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/database";
import { Alert } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import { connect } from "react-redux";
import {
  SYSTEM_NOTIFICATIONS_RTDB_PATH,
  SystemNotificationRecord,
  alertColorForNotificationType,
  formatSystemNotificationTimestamp,
  parseActiveSystemNotifications,
} from "../../../utils/systemNotifications";
import s from "./SystemNotificationBannerStack.scss";

interface Props {
  isLoggedIn: boolean;
}

function SystemNotificationBannerStackView({ isLoggedIn }: Props) {
  const [active, setActive] = useState(parseActiveSystemNotifications(null));

  useEffect(() => {
    if (!isLoggedIn) {
      setActive([]);
      return undefined;
    }

    const ref = firebase.database().ref(SYSTEM_NOTIFICATIONS_RTDB_PATH);
    const onValue = (snapshot: firebase.database.DataSnapshot) => {
      const data = snapshot.val() as Record<string, SystemNotificationRecord> | null;
      setActive(parseActiveSystemNotifications(data));
    };

    ref.on("value", onValue);
    const tick = window.setInterval(() => {
      setActive(current =>
        current.filter(entry => entry.record.expiresAt > Date.now())
      );
    }, 60_000);

    return () => {
      ref.off("value", onValue);
      window.clearInterval(tick);
    };
  }, [isLoggedIn]);

  if (!isLoggedIn || active.length === 0) {
    return null;
  }

  const stackColor = alertColorForNotificationType(active[0].record.type);

  return (
    <div className={s.stack} data-testid="system-notification-banner-stack">
      <Alert color={stackColor} className={`${s.banner} mb-0 rounded-0`}>
        <div className={s.header}>Notifications</div>
        {active.map(({ id, record }) => (
          <div key={id} className={s.line}>
            <span className={s.bannerText}>
              <strong className={s.timestamp}>
                {formatSystemNotificationTimestamp(record.createdAt)}
              </strong>
              {" - "}
              {record.message}
            </span>
          </div>
        ))}
        <div className={s.helpLine}>
          <span className={s.bannerText}>
            If you have any questions or doubts, feel free to email us at{" "}
            <a className={s.helpLink} href="mailto:help@viewspark.com">
              help@viewspark.com
            </a>
          </span>
        </div>
      </Alert>
    </div>
  );
}

const mapStateToProps = (state: { user: { isLoggedIn: boolean } }) => ({
  isLoggedIn: state.user.isLoggedIn,
});

export default connect(mapStateToProps)(
  withStyles(s)(SystemNotificationBannerStackView)
);
